import { useEffect, useRef } from 'react';

export const useRachelAttachmentPreview = (file: File) => {
  const imageRef = useRef<HTMLImageElement>(null);

  useEffect(() => {
    const objectUrl = URL.createObjectURL(file);
    const image = imageRef.current;

    if (image) {
      image.src = objectUrl;
    }

    return () => URL.revokeObjectURL(objectUrl);
  }, [file]);

  return imageRef;
};
